/**
 * Règle du mot de passe, commune à l'inscription, la réinitialisation et le profil (MOKA-360,
 * MOKA-363) : 8 caractères, une minuscule, une majuscule, un chiffre et un caractère qui n'est
 * ni une lettre ni un chiffre (- _ . ! # espace…). L'ancienne liste fermée (@$!%*?&) refusait
 * sans le dire les mots de passe générés par les gestionnaires.
 */
export const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

/** Le mot de passe contient un caractère spécial au sens de la règle. */
export const hasSpecialChar = (value: string): boolean => /[^A-Za-z0-9]/.test(value);
